export default __webpack_public_path__ + "static/media/138.073c1653.jpg";